import { E_HomeBanner } from "../../../../../enums/home-banner-type.enum";
import { E_NurseTableCellType } from "../../../../../enums/nurse-plan-display/table-cell-type.enum";
import { E_WebDisplayCellType } from "../../../../../enums/smart-display/cell-type.enum";
import { ChangesDetection } from "../../../../change-detection";
import { I_HomeConfigResponse, I_BannerItemResponse, I_BannerItemConfigResponse, I_BannerItemTableConfigResponse, I_BannerItemTableCellConfig, I_MedicalStaffConfigResponse, I_BannerItemTableCellConfigResponse } from "../api/home-config.response";

export class C_HomeConfig extends ChangesDetection {
    minColumnSize?: string;
    columnsPerBreakpoint?: number;
    breakpointSize?: string;
    cardAspectRatioHeight?: string;
    cardAspectRatioWidth?: string;

    constructor(data?: I_HomeConfigResponse) {
        super();
        if (!data) return;
        this.initialize(data);
    }

    initialize(data: I_HomeConfigResponse) {
        if (data.minColumnSize) this.minColumnSize = data.minColumnSize;
        if (data.columnsPerBreakpoint) this.columnsPerBreakpoint = data.columnsPerBreakpoint;
        if (data.breakpointSize) this.breakpointSize = data.breakpointSize;
        if (data.cardAspectRatioHeight) this.cardAspectRatioHeight = data.cardAspectRatioHeight;
        if (data.cardAspectRatioWidth) this.cardAspectRatioWidth = data.cardAspectRatioWidth;

    }
}

export class C_BannerList extends ChangesDetection {
    list: {
        [type: string]: C_BannerItem;
    } = {};

    constructor(info?: I_BannerItemResponse[]) {
        super();
        if (!info) return;
        this.reNewBanners(info);
    }

    reNewBanners(banners: I_BannerItemResponse[]) {
        // 1. Primero, iteramos sobre los banners nuevos para agregar o actualizar los existentes
        banners.forEach((banner, index) => {
            this.addNewBanner(banner, index);
        });

        // 2. Luego, eliminamos los banners que ya no están en la lista de datos nuevos
        this.removeOldBanners(banners);

        // 3. Forzamos la actualización de la detección de cambios
        this.forceUpdateDetection();
    }

    addNewBanner(banner: I_BannerItemResponse, index: number) {
        this.list[banner.type] = new C_BannerItem(banner, index);
    }

    hasEntries(): boolean {
        return !!Object.values(this.list).some( bannerItem => bannerItem.type == E_HomeBanner.Inputs);
    }

    // Método para eliminar los banners que ya no están en los datos nuevos
    removeOldBanners(banners: I_BannerItemResponse[]) {
        // Creamos un conjunto de tipos de los banners nuevos
        const newTypes = new Set(banners.map(banner => banner.type));

        // Iteramos sobre los elementos actuales de la lista
        Object.keys(this.list).forEach(type => {
            if (!newTypes.has(type as E_HomeBanner)) {
                // Si el tipo del banner no está en los nuevos datos, lo eliminamos
                delete this.list[type];
            }
        });
    }
}

export class C_BannerItem extends ChangesDetection {

    type?: E_HomeBanner;
    growPriority?: number;
    order: number = 0;
    config: C_BannerItemConfig = new C_BannerItemConfig();

    constructor(json?: I_BannerItemResponse, index?: number) {
        super();
        if (!json) return;
        if (json.type) this.type = json.type;
        if (json.growPriority) this.growPriority = json.growPriority;
        if (json.config) this.config.initialize(json.config);
        if (index != undefined && !isNaN(index)) this.order = index;
        this.forceUpdateDetection();
    }

}

export class C_BannerItemConfig extends ChangesDetection {

    bannerItemTableConfig: C_BannerItemTableConfig = new C_BannerItemTableConfig();
    dialogsConfigList: C_BannerItemTableConfig = new C_BannerItemTableConfig();
    medicalStaffConfig: C_MedicalStaffConfig = new C_MedicalStaffConfig();

    constructor(json?: I_BannerItemConfigResponse) {
        super();
        if (json) this.initialize(json);
    }

    initialize(json: I_BannerItemConfigResponse) {
        if (json.bannerItemTableConfig) this.bannerItemTableConfig.initialize(json.bannerItemTableConfig);
        if (json.bannerItemDialogTableConfig) this.dialogsConfigList.initialize(json.bannerItemDialogTableConfig);
        if (json.medicalStaffConfig) this.medicalStaffConfig.initialize(json.medicalStaffConfig);
        this.forceUpdateDetection();
    }
}

export class C_BannerItemTableConfig extends ChangesDetection {

    config: C_BannerItemTableCellConfig[] = [];

    constructor(json?: I_BannerItemTableConfigResponse) {
        super();
        if (json) this.initialize(json);
    }

    initialize(json: I_BannerItemTableConfigResponse) {
        if (json.config) {
            this.config = []
            json.config.forEach((e) => this.config.push(new C_BannerItemTableCellConfig(e)));
        };
        this.forceUpdateDetection();
    }

    toConfigResponse(): I_BannerItemTableCellConfig[] {
        return this.config.map(b => b.toConfigResponse());
    }
}

export class C_MedicalStaffConfig extends ChangesDetection {

    hasTeams: boolean = false;
    staffAmount: number = 0;

    constructor(json?: I_MedicalStaffConfigResponse) {
        super();
        if (json) this.initialize(json);
    }

    initialize(json: I_MedicalStaffConfigResponse) {
        if (json.hasTeams != null) this.hasTeams = json.hasTeams
        if (json.staffAmount != null) this.staffAmount = json.staffAmount
        this.forceUpdateDetection();
    }
}

export class C_BannerItemTableCellConfig {

    type?: E_WebDisplayCellType | E_NurseTableCellType;
    title?: string;
    field: string[] = [];
    growPriority?: number;
    icon?: boolean;

    constructor(json?: I_BannerItemTableCellConfigResponse) {
        if (json) this.initializeFromJson?.(json);
    }

    initializeFromJson?(json: I_BannerItemTableCellConfigResponse) {
        if (json.type) this.type = json.type;
        if (json.title) this.title = json.title;
        if (json.field) this.field = json.field;
        if (!isNaN(json.growPriority)) this.growPriority = json.growPriority;
        if (json.icon != null && json.icon != undefined) this.icon = json.icon;
    }

    toConfigResponse(): I_BannerItemTableCellConfig {
        return {
            field: this.field,
            growPriority: this.growPriority,
            icon: this.icon,
            title: this.title,
            type: this.type,
        }
    }
}


